<div class="mdk-drawer-layout__content page">
    <div class="container-fluid page__heading-container">
        <div class="page__heading d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-lg-between text-center text-lg-left">
            <h1 class="m-lg-0">Accounts Transactions</h1>
            <!-- 
            "listRequests","readRequests","","","importRequests"               *ngIf="userService.rolesArrayPermission.includes('addRequests')"-->
            <div class="row">
                <div class=" col-md-6 ">
                    <button style="width: max-content" class="btn btn-primary " *ngIf="userService.rolesArrayPermission.includes(
            'addCustomerAccounts') " (click)=" viewcustomerAccountTransactionCSVmodel(viewCustomerAccountTransactionCSV) ">
                        <i class="material-icons mr-2 ">add_circle</i>
                        Customer Transaction file</button>
                </div>
                <div class=" col-md-6 ">
                    <button style="width: max-content; float:right;" class="btn btn-primary ml-lg-3 float-right" [routerLink]="['/customeraccountstransaction/addCustomerAccountTransaction']">
                        <i class="material-icons mr-2">add_circle</i>Add New</button>
                </div>
            </div>
        </div>
        <!-- [routerLink]="['/banner/addBanner', data?.id]" -->
    </div>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
                    <thead>
                        <tr>
                            <th width="50px">#</th>
                            <th width="100px">Name</th>
                            <th width="100px">Account Type</th>                           
                            <th width="100px">Amount</th>
                            <th width="100px">Date<th>
                                <th>Decscription</th>
                            <th width="50px">Transaction Type</th>
                            <th width="150px">Action</th> 
                        </tr>
                    </thead>
                    <tbody *ngIf="bannersList && bannersList.length > 0">
                        <tr *ngFor="let banner of bannersList; let index = index">
                            <td>{{index + 1}}</td>
                            <td>{{banner?.customer.name}}</td>
                            <td class="capitalize">{{banner?.account.name}}</td>
                         
                            <td >{{banner?.amount}}</td>
                            <td >{{banner?.date}}</td>
                            <td>{{banner?.description}}</td>
                           
                            <td>{{banner?.transaction_type}}</td>
                            
                            <td>
                                <button class="btn bg-transparent" *ngIf="userService.rolesArrayPermission.includes('editRequests')"
                                    [routerLink]="['/customeraccountstransaction/addCustomerAccountTransaction', banner?.id]">
                                    <a class="edit" title="Edit" data-toggle="tooltip"><i class="material-icons">&#xE254;</i></a>
                                </button>
                                <button class="btn bg-transparent">
                                    <a class="view" title="view" data-toggle="tooltip"
                                        (click)="viewBannerDetails(viewBanners, banner?.id)"><i
                                            class="material-icons">visibility</i></a>
                                </button>
            
                            </td>
            
                        </tr>
                    </tbody>
                </table> -->


                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
                    <thead>
                        <tr style="text-align: center;">
                            <th width="50px">Id</th>
                            <th width="50px">Name</th>
                            <th width="50px">Account Number</th>
                            <th width="50px">Account Type</th>
                            <th width="50px">Amount</th>
                            <th width="100px">Date</th>
                            <th width="50px">Description</th>
                            <th width="50px">Transaction Type</th>
                            <th width="100px">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let transaction of transactionList" style="text-align: center;">
                            <td>{{transaction.id}}</td>
                            <td>{{transaction.customer.name}}</td>
                            <td>{{transaction.number}}</td>
                            <td>{{transaction.account.name}}</td>
                            <td>{{transaction.amount | currency:currency}}</td>
                            <td>{{transaction.date|date:'dd/MM/yyyy, hh:mm a'}}</td>
                            <td>{{transaction.description}}</td>
                            <td>{{transaction.transaction_type}}</td>
                            <td>
                                <button class="btn bg-transparent" *ngIf="userService.rolesArrayPermission.includes('editCustomerAccountTransactions')" [routerLink]="['/customeraccountstransaction/addCustomerAccountTransaction', transaction?.id]">

                                    <a class="edit" title="Edit" data-toggle="tooltip">
                                        <i class="material-icons">&#xE254;</i>
                                    </a>
                                </button>

                                <button class="btn bg-transparent">
                                    <a class="view" title="view" data-toggle="tooltip">
                                        <i class="material-icons" (click)="viewAccountTransactionDetails(viewAccountTransactions, transaction.id)">visibility</i>
                                    </a>
                                </button>

                                <button class="btn bg-transparent" *ngIf="userService.rolesArrayPermission.includes('AccessBranches')">
                                    <a class="view" title="view" data-toggle="tooltip">
                                        <i class="material-icons" (click)="openAccess(content,transaction)">lock_open</i>
                                    </a>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>

<ng-template #viewAccountTransactions let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="container emp-profile">
                <form method="post">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="float-right" style="width: 80px;">
                                <input type="submit" *ngIf="userService.rolesArrayPermission.includes('editCustomerAccountTransactions')" [routerLink]="['/customeraccountstransaction/addCustomerAccountTransaction', viewBanner?.id]"
                                    class="profile-edit-btn" (click)="closeModal()" name="btnAddMore" value="Edit" />
                            </div>
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div *ngIf="fileToReturn" class="mt-2 text-center pointer col-md-4">
                                    <button (click)="uploadBannerImage(viewBanner?.id)">Upload</button>
                                </div>
                                <div class="col-md-4"></div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <!-- <div class="float-right" style="width: 80px;">
                                <input type="submit" *ngIf="userService.rolesArrayPermission.includes('addBanners')"
                                    [routerLink]="['/banners/addBanner', viewBanner?.id]" class="profile-edit-btn"
                                    (click)="closeModal()" name="btnAddMore" value="Edit" />
                            </div> -->
                            <div class="profile-head">
                                <!-- <h5>
                                    {{viewBanner?.number}}
                                </h5> -->
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content profile-tab" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div class="row" *ngIf="viewBanner?.account.number">
                                        <div class="col-md-4">
                                            <label>Account number</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.number}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.customer?.name">
                                        <div class="col-md-4">
                                            <label>Customer Name</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.customer?.name}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.status">
                                        <div class="col-md-4">
                                            <label>Transaction Type</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.transaction_type}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.transaction_mode">
                                        <div class="col-md-4">
                                            <label>Mode</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.transaction_mode}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.amount">
                                        <div class="col-md-4">
                                            <label>Amount</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.amount | currency:currency}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.date">
                                        <div class="col-md-4">
                                            <label>Date</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.date|date:'dd/MM/yyyy'}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.transaction_time">
                                        <div class="col-md-4">
                                            <label>Time</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.transaction_time}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.description">
                                        <div class="col-md-4">
                                            <label>Description</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.description}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.branch_id">
                                        <div class="col-md-4">
                                            <label>Branch ID</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.branch_id}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-footer">
                <button (click)="closeModal()" class="btn btn-primary float-right">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cropeImage let-close="close">
    <div class="modal-header">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 2" (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close(); resetSelectedImage(fileInput)">Cancel</button>
        <button type="button" class="btn btn-outline-secondary" (click)="close()">Confirm</button>
    </div>
</ng-template>

<ng-template #viewCustomerAccountTransactionCSV let-model style="width: 813px !important;
height: 600px !important;">
    <div class="container " data-backdrop="static" data-keyboard="false">
        <button (click)="closeModal()" class="btn btn-primary float-right ">close</button>
        <div class="row custome Padding">

            <div class="col-md-12">

                <p>you can upload on excel file to create multiple customer accounts at once.</p>
                <div>
                    <span>Sample Excel file:</span>

                </div>
                <a href="./assets/files/customerAccountTransaction.csv" download> customer_accounts_transaction_upload_templates.xls</a>
            </div>

            <div class="col-md-12
            customePadding">
                <p>Select Spreadsheet file :</p>

                <input type="file" name="files" class="form-control" #uploads (change)="fileChangeListenera(uploads.files)" multiple value="process"
                    accept=".csv, .xls, .xlsx" />
                <!-- (change)="fileChangeListenera(uploads.files)" -->
            </div>
            <div class="col-md-12" *ngIf="collection.length>0">
                <div class=" col-md-12 text-right ">
                    <button class="btn btn-primary " (click)="uploadRowData() ">System Data import </button>
                </div>

            </div>
            <div class="col-md-12" *ngIf="collection.length>0" style="max-height:600px;overflow:auto !important">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Transaction Type</th>
                            <th scope="col">Transaction Mode</th>
                            <th scope="col">Customer Account ID</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Date</th>
                            <th scope="col">Description</th>
                            <th scope="col">Branch ID</th>
                            <th scope="col">Response</th>
                            <th scope="col">Error</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of collection ;index as i">
                            <td>{{item.customer_account_transaction.transaction_type ? i+1 : null}}</td>
                            <td>{{item.customer_account_transaction.transaction_type}}</td>
                            <td>{{item.customer_account_transaction.transaction_mode}}</td>
                            <td>{{item.customer_account_transaction.customer_account_id}}</td>
                            <td>{{item.customer_account_transaction.amount}}</td>
                            <td>{{item.customer_account_transaction.date}}</td>
                            <td>{{item.customer_account_transaction.description}}</td>
                            <td>{{item.customer_account_transaction.branch_id}}</td>
                            <td>{{item.customer_account_transaction.response}}</td>
                            <td>{{item.customer_account_transaction.error}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>